import { render, staticRenderFns } from "./AchievementsPerCompetenceTable.vue?vue&type=template&id=5958a14f&scoped=true"
import script from "./AchievementsPerCompetenceTable.vue?vue&type=script&lang=js"
export * from "./AchievementsPerCompetenceTable.vue?vue&type=script&lang=js"
import style0 from "./AchievementsPerCompetenceTable.vue?vue&type=style&index=0&id=5958a14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5958a14f",
  null
  
)

export default component.exports